export enum ItemType {
    Product = "Product",
    Service = "Service"
}